<template>
  <div
    class="container-fluid infinite-list"
    infinite-scroll-immediate="false"
    infinite-scroll-disabled="disabled"
    v-infinite-scroll="getDemandList"
  >
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <!-- 申請日期 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">申請日期</label>
              <el-date-picker
                class="w-100"
                type="daterange"
                range-separator="~"
                start-placeholder="yyyy-MM-dd"
                end-placeholder="yyyy-MM-dd"
                v-model="applyDateRange"
              />
            </div>
          </div>

          <!-- 需求單單號 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">{{ i18n("Basic.DemandNo") }}</label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model="searchCondition.ManpowerDemandNo"
              />
            </div>
          </div>

          <!-- 需求單名稱 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">需求單名稱</label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model="searchCondition.ManpowerDemandName"
              />
            </div>
          </div>

          <!-- 職務名稱 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">{{ i18n("Position.PositionName") }}</label>
              <el-select
                class="w-100"
                filterable
                clearable
                placeholder="請選擇"
                v-model="searchCondition.PositionCode"
              >
                <el-option
                  v-for="position in positionOptions"
                  :key="position.Code"
                  :label="position.Name"
                  :value="position.Code"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 申請部門 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">{{ i18n("Basic.ApplyDepartment") }}</label>
              <treeselect
                :options="departmentOptions"
                :searchable="true"
                :show-count="true"
                :default-expand-level="1"
                placeholder="請選擇"
                v-model="searchCondition.demandDepartmentGuid"
              >
                <label
                  slot="option-label"
                  slot-scope="{
                    node,
                    shouldShowCount,
                    count,
                    labelClassName,
                    countClassName,
                  }"
                  :class="labelClassName"
                  for=""
                >
                  {{ node.label }}
                  <span v-if="shouldShowCount" :class="countClassName">
                    ({{ count }})
                  </span>
                </label>
              </treeselect>
            </div>
          </div>

          <!-- 申請人 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">申請人</label>
              <el-select
                class="w-100"
                filterable
                clearable
                placeholder="請選擇"
                v-model="searchCondition.ApplicantGuid"
              >
                <el-option
                  v-for="employee in employeeOptions"
                  :key="employee.Guid"
                  :label="employee.Name"
                  :value="employee.Guid"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 需求單狀態 -->
          <div class="col-sm-12 col-md-3">
            <div class="form-group">
              <label for="">需求單狀態</label>
              <el-select
                class="w-100"
                clearable
                placeholder="請選擇"
                v-model="searchCondition.ManpowerDemandStatus"
              >
                <el-option
                  v-for="status in statusOptions"
                  :key="status.Key"
                  :label="status.Value"
                  :value="status.Key"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 按鈕 -->
          <div class="col-sm-3 col-md">
            <button
              type="button"
              class="btn btn-primary btn-search"
              style="margin-top: 30px"
              @click="
                (currentPage = 1),
                  (personList = []),
                  (totalDemand = 0),
                  getDemandList()
              "
            >
              {{ i18n("Buttons.Search") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="demandList.length > 0">
      <div class="tool-list-about-card">
        <span
          @click="gridStyle = 'block'"
          :class="{ active: gridStyle == 'block' }"
        >
          <eva-icon fill="#000" name="grid-outline" />
        </span>
        <span
          @click="gridStyle = 'list'"
          :class="{ active: gridStyle == 'list' }"
        >
          <eva-icon fill="#000" name="list-outline" />
        </span>
      </div>
    </div>

    <!-- 卡片列表 -->
    <div
      class="demand-card-list"
      :class="{
        'list-style': gridStyle === 'list',
        'block-style': gridStyle === 'block',
      }"
    >
      <div
        v-for="demand in demandList"
        :key="demand.Guid"
        class="demand-card infinite-list-item"
      >
        <DemandCard
          ref="demandCard"
          :category="'review'"
          :data="demand"
          :showCheckbox="true"
          @updateSelectDemand="updateSelectDemand"
        >
        </DemandCard>
      </div>
    </div>

    <!-- 功能列 -->
    <ActionBar
      :show="showActionBar"
      :cardType="'demandCard'"
      :cardStatus="cardStatus"
      :selectedCardList="chooseDemandList"
      @showActionBar="showActionBar = !showActionBar"
      @selectAllCards="selectAllCards"
      @clearSelectCard="clearSelectCard"
    >
      <template v-slot:button="{ props }">
        <button
          v-if="props === 'Pending'"
          type="button"
          class="action-btn"
          @click="openActionModal({ action: 'Approved' })"
        >
          <eva-icon name="radio-button-off-outline" fill="#FFF" />
          <span>同意</span>
        </button>

        <button
          v-if="props === 'Pending'"
          type="button"
          class="action-btn"
          style="background-color: red"
          @click="openActionModal({ action: 'Rejected' })"
        >
          <eva-icon name="close-outline" fill="#FFF" />
          <span>否決</span>
        </button>
      </template>
    </ActionBar>

    <!-- 同意 & 否決 Modal -->
    <div
      id="actionModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <span v-if="changeStatus === 'Approved'">同意</span>
            <span v-else>否決</span>
          </div>
          <div class="modal-body">
            <span v-if="changeStatus === 'Approved'">確認同意?</span>
            <span v-else>確認否決?</span>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="changeDemandStatus"
            >
              確認
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 檢視需求單 -->
    <DemandDetailModal />

    <!-- API 回應訊息 -->
    <ResponseDataModal
      :successfulList="successMessage"
      :failedList="failMessage"
    />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 需求單卡片
import DemandCard from "@/components/back/Card/Demand";
// 功能列
import ActionBar from "@/components/back/ToolBar/ActionBar";
import DemandDetailModal from "@/components/back/Modal/DemandDetail";
import ResponseDataModal from "@/components/back/Modal/ResponseData";

export default {
  name: "DemandReview",

  components: {
    DemandCard,
    ActionBar,
    DemandDetailModal,
    ResponseDataModal,
  },
  data() {
    return {
      // 需求單列表顯示樣式(區塊/條列)
      gridStyle: "block",

      // 需求單狀態
      statusOptions: [
        { Key: "Pending", Value: "待決" },
        { Key: "Approved", Value: "同意" },
        { Key: "Rejected", Value: "否決" },
      ],

      // 查詢
      applyDateRange: [], // 申請日期
      positionOptions: [], // 職務列表
      departmentOptions: [], // 部門列表
      employeeOptions: [], // 申請人列表

      searchCondition: {
        ManpowerDemandStatus: "Pending",
      },

      cardStatus: null, // 卡片狀態

      // 需求單
      demandList: [], // 列表

      // 分頁
      totalDemand: 0, // 總數
      currentPage: 1, // 當前頁數

      // API 回應資訊
      successMessage: [], // 成功訊息
      failMessage: [], // 失敗訊息

      // 功能列
      showActionBar: false, // 預設不顯示

      // 需求單欲改變狀態
      changeStatus: null,

      // 選取之需求單列表
      chooseDemandList: [],
    };
  },

  methods: {
    // 取得需求審核列表
    getDemandList() {
      if (this.totalDemand > 0) {
        if (this.totalDemand > 36) {
          if (this.totalDemand === this.demandList.length) {
            this.stopGetNextPage = true;
            return;
          } else {
            this.currentPage++;
            this.stopGetNextPage = false;
          }
        } else {
          this.stopGetNextPage = true;
          return;
        }
      }

      this.cardStatus = this.searchCondition.ManpowerDemandStatus;
      this.updateLoading(true);

      this.$api.manpowerDemand
        .getManpowerDemandStatus({
          ...this.searchCondition,
          StartDate:
            this.applyDateRange === null
              ? null
              : this.dayjs(this.applyDateRange[0]).format("YYYY-MM-DD"),
          EndDate:
            this.applyDateRange === null
              ? null
              : this.dayjs(this.applyDateRange[1]).format("YYYY-MM-DD"),
          ManpowerDemandSupervisorGuid: this.$cookies.get("userId"),
          Page: this.currentPage,
          PerPage: 36,
        })
        .then((response) => {
          if (response.status === 200) {
            let newArr = response.data.Datas.map((element) => {
              let demandItem = {
                ...element,
                isChecked: false,
              };
              return demandItem;
            });

            let oldArr;
            if (this.currentPage === 1) {
              oldArr = [];
            } else {
              oldArr = this.demandList;
            }
            this.demandList = oldArr.concat(newArr);
          }
          this.updateLoading(false);
        });
    },

    // 即時更新選取需求單之列表
    updateSelectDemand(chooseDemand) {
      let repeatIndex = this.chooseDemandList.findIndex(
        (element) => element.Guid === chooseDemand.Guid
      );
      repeatIndex === -1
        ? this.chooseDemandList.push(chooseDemand)
        : this.chooseDemandList.splice(repeatIndex, 1);
    },

    // 審核 需求單
    changeDemandStatus() {
      let chooseDemand = this.chooseDemandList.map((item) => item.Guid);
      $("#actionModal").modal("hide");
      this.updateLoading(true);

      this.$api.manpowerDemand
        .postApproved({
          Sender: this.$cookies.get("userName"),
          SenderGuid: this.$cookies.get("userId"),
          Status: this.changeStatus,
          ManpowerDemandGuid: chooseDemand,
        })
        .then((response) => {
          if (response.status === 200) {
            this.successMessage = response.data.filter((item) => {
              return item.indexOf("成功") !== -1;
            });
            this.failMessage = response.data.filter((item) => {
              return item.indexOf("失敗") !== -1;
            });
            this.$store.commit("OpenResponseDataModal", true);

            chooseDemand.map((item) => {
              this.demandList.forEach((ele, index, arr) => {
                if (ele.Guid === item) {
                  arr.splice(index, 1);
                }
              });
            });

            this.clearSelectCard();
          }
          this.updateLoading(false);
        });
    },

    // Action Modal
    openActionModal({ action }) {
      this.changeStatus = action;
      $("#actionModal").modal("show");
    },

    // 全選
    selectAllCards() {
      this.demandList.forEach((item) => {
        if (!item.isChecked) {
          item.isChecked = true;
        }
      });
      this.chooseDemandList = this.demandList.filter(
        (item) => item.isChecked === true
      );
    },

    // 清除
    clearSelectCard() {
      this.demandList.forEach((item) => {
        item.isChecked = false;
      });
      this.chooseDemandList = [];
    },

    async getData() {
      try {
        // 取得 員工
        const backgroundUser =
          await this.$api.backgroundUser.getBackgroundUser();
        this.employeeOptions = backgroundUser.data.map((user) => {
          return {
            Guid: user.UserId,
            Name: user.Name,
          };
        });
        // 取得 部門
        const department = await this.$api.department.getDepartment();
        this.departmentOptions = department.data;
        // 取得 職務
        const position = await this.$api.position.getPositionPaging({
          isPaging: false,
        });
        this.positionOptions = position.data.Datas.map((item) => {
          return {
            Code: item.PositionCode,
            Name: item.PositionName,
          };
        });
        await this.getDemandList();
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    disabled() {
      return this.stopGetNextPage;
    },

    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    chooseDemandList: function (e) {
      this.showActionBar = e.length > 0;
    },
  },

  created() {
    this.applyDateRange = [this.$common.getLastWeek(), this.$common.getToday()];
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
